import { Flag } from "@kanda-libs/ks-frontend-services";
import { capitaliseWords, formatDateForDisplay } from "common/helpers";
import { pipe } from "fp-ts/lib/function";

const sortFlagsNewestFirst = (a: Flag, b: Flag) => {
  const aDate = a?.flagged_at?.getTime() || 0;
  const bDate = b?.flagged_at?.getTime() || 0;

  return bDate - aDate;
};

const formatFlagAsTimelineItem = (flag: Flag): TimelineItem => ({
  title: [capitaliseWords(flag.level), flag.remark].filter(Boolean).join(" : "),
  date: formatDateForDisplay(flag.flagged_at as Date),
  fill: flag.level,
});

export interface TimelineItem {
  title: string;
  date: string;
  fill: string;
}

export const formatFlagsAsTimelineItems = (flags: Flag[]): TimelineItem[] =>
  pipe(
    flags,
    (currentFlags) => [...currentFlags].sort(sortFlagsNewestFirst),
    (currentFlags) => currentFlags.map(formatFlagAsTimelineItem)
  );
